import { proxyCustomElement, HTMLElement, getAssetPath, h } from '@stencil/core/internal/client';
import { i as SvgService } from './index2.js';
import { D as DomService, a as DomOrigin } from './index3.js';

const rocheIconCss = ":host{display:block;margin-top:3rem;margin-top:0}@media (min-width: 90rem){:host{margin-top:4.5rem}}:host,:host *{box-sizing:border-box}@media (min-width: 64rem){:host{margin-top:0}}:host .icon-container{display:flex;justify-content:center}:host .icon-rtl{transform:rotateY(180deg)}";
const RocheIconStyle0 = rocheIconCss;

const defaultHeight = '1rem';
// eslint-disable-next-line no-self-compare
const isInfinityOrNaN = (value) => value === Infinity || value !== value;
const isSafeValue = (value) => !!value && !isInfinityOrNaN(parseFloat(value));
const IconsRightToLeft = ['arrow-left', 'arrow-light-left', 'arrow-light-right', 'arrow-right', 'chevron-left', 'chevron-right', 'diagnostics', 'external-link', 'file-download', 'file', 'list', 'stock-down', 'stock-equal', 'stock-up', 'loading'];
const isFullUrl = (url) => url.substr(0, 'http://'.length) === 'http://'
    || url.substr(0, 'https://'.length) === 'https://';
const replaceOrigin = (url, newOrigin) => {
    const [protocol, fullPath] = url.split('//');
    const [, ...path] = (fullPath || '').split('/');
    return [protocol, [newOrigin, ...path].join('/')].join('//');
};
const RocheIcon = /*@__PURE__*/ proxyCustomElement(class RocheIcon extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.icon = undefined;
        this.height = undefined;
        this.width = undefined;
        this.origin = undefined;
        this.isRightToLeft = undefined;
        this.svg = undefined;
    }
    async fetchIconSvg() {
        this.svg = await SvgService.getSvg(this.icon, this.props, this.basePath);
    }
    get heightParsed() {
        return isSafeValue(this.height) ? this.height : undefined;
    }
    get widthParsed() {
        return isSafeValue(this.width) ? this.width : undefined;
    }
    get originParsed() {
        const { domOrigin } = DomService.getGlobalConfig();
        return this.origin || domOrigin || DomOrigin.REQUEST_SERVER;
    }
    get basePath() {
        let assetPath = getAssetPath('');
        assetPath = assetPath.endsWith('/') ? assetPath.slice(0, -1) : assetPath;
        const currentPath = `${assetPath.substring(0, assetPath.lastIndexOf('/'))}/`;
        const isPreviewUrl = isFullUrl(currentPath);
        const isLocalDevelopment = DomService.getLocationHostname() === 'localhost';
        return this.originParsed === DomOrigin.REQUEST_SERVER && isPreviewUrl && !isLocalDevelopment
            ? replaceOrigin(currentPath, window.location.host)
            : currentPath;
    }
    get props() {
        const { widthParsed: width, heightParsed: height } = this;
        return !height && !width ? {
            height: defaultHeight,
        } : {
            height,
            width,
        };
    }
    async componentWillLoad() {
        await this.fetchIconSvg();
    }
    componentDidLoad() {
        DomService.handleTextDirection(this.element);
        this.isRightToLeft = this.element.getAttribute('dir') === 'rtl';
    }
    render() {
        const classList = {
            'icon-container': true,
            'icon-rtl': this.isRightToLeft && IconsRightToLeft.includes(this.icon),
        };
        return (h("div", { key: 'e26aee85d7566fbf7116298c32673db1c181b73a', class: classList, innerHTML: this.svg }));
    }
    get element() { return this; }
    static get watchers() { return {
        "icon": ["fetchIconSvg"]
    }; }
    static get style() { return RocheIconStyle0; }
}, [1, "roche-icon", {
        "icon": [1],
        "height": [1],
        "width": [1],
        "origin": [1],
        "isRightToLeft": [32],
        "svg": [32]
    }, undefined, {
        "icon": ["fetchIconSvg"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-icon"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-icon":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RocheIcon);
            }
            break;
    } });
}

export { RocheIcon as R, defineCustomElement as d };

//# sourceMappingURL=roche-icon2.js.map